import {
  MultiSectionLayout,
  Tab,
} from "@jugl-web/ui-components/cross-platform";
import React, { useMemo } from "react";
import {
  HeaderBreadcrumbs,
  HeaderBreadcrumbsProps,
} from "@jugl-web/ui-components/web";

export type TabItem = {
  id: string;
  title: string;
  hidden?: boolean;
  href?: string;
  count?: number;
  counterClassName?: string;
  number?: number;
  onClick?: () => void;
};

export type TabsLayoutProps = {
  tabs: TabItem[];
  selectedTab: string;
  breadcrumbProps?: HeaderBreadcrumbsProps;
  header?: React.ReactNode;
  rightContent?: React.ReactNode;
  children: React.ReactNode;
};

export const TabsLayout: React.FC<TabsLayoutProps> = ({
  children,
  tabs,
  breadcrumbProps,
  header,
  selectedTab,
  rightContent,
}) => {
  const filteredTabs = useMemo(
    () => tabs.filter(({ hidden }) => !hidden),
    [tabs]
  );

  return (
    <MultiSectionLayout
      header={
        <>
          {header}
          {breadcrumbProps && (
            <HeaderBreadcrumbs
              disableShadow={!!filteredTabs.length}
              {...breadcrumbProps}
            />
          )}
          {(!!filteredTabs.length || !!rightContent) && (
            <div className="flex h-[72px] items-center justify-between bg-[#EEF2F5] px-8">
              <div className="flex h-full items-end gap-1">
                {filteredTabs.map((option) => (
                  <Tab
                    key={option.id}
                    title={option.title}
                    isSelected={option.id === selectedTab}
                    count={option.count}
                    onClick={option.onClick}
                    counterClassName={option.counterClassName}
                    number={option.number}
                  />
                ))}
              </div>
              {rightContent && <div>{rightContent}</div>}
            </div>
          )}
        </>
      }
    >
      {children}
    </MultiSectionLayout>
  );
};
